import { Flex, Heading } from '@radix-ui/themes';

import { EditOutlinedIcon } from 'shared/icons';

import { CreateResumeMode } from './create-resume.store';

import './resume-header.scss';

const RESUME_HEADER_TITLE: Record<CreateResumeMode, string> = {
  [CreateResumeMode.CREATE]: 'Створити резюме',
  [CreateResumeMode.EDIT]: 'Редагувати резюме',
  [CreateResumeMode.COPY]: 'Копіювати резюме',
};

export type ResumeHeaderProps = {
  mode: CreateResumeMode;
};

export const ResumeHeader = ({ mode }: ResumeHeaderProps) => {
  return (
    <Flex align="center" gap="2" className="resume-header">
      <img src='/Images/employerSide/icon8color.png' alt='' />
      <Heading as="h1" size="6" weight="medium" className="resume-header__title">
        {RESUME_HEADER_TITLE[mode]}
      </Heading>
    </Flex>
  );
};
